import {useState} from 'react'
import Axios from 'axios'
import { useTranslation } from "react-i18next"
import Swal from 'sweetalert2'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'

/**
 * 
 * @returns 
 */
export const Forgot = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    
    /**
     * Comprueba los datos del formulario
     * @param {*} e evento
     */
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Obtenemos el mail del usuario
        const clientEmail = e.target.email.value

        setIsLoading(true);
        
        // Enviamos la petición al /forgotpassword con el email
        await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/sendmail', {email: clientEmail})
            .then((res) => {
                setIsLoading(false);
                navigate('/emailsend/'+clientEmail)
            }).catch((err) => {
                setIsLoading(false);
                // Mostramos el popup informativo
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'error',
                    text: 'Ha habido un error al intentar enviar los datos, comprueba el correo introducido o vuelva a intentarlo más tarde'
                })
            });
    } 
    return (
        <Container>
            <Row className="my-3 d-flex align-content-center">
                <Col className='p-0 d-flex align-content-center'>
                    <Link className="btn my-3 px-5" to="/login">
                        <img src="../images/arrow-back.svg" alt="eyes" width={25}></img>
                    </Link>
                </Col>
                <Col className='text-center'>
                    <h1 className='m-3'>{t('forgot.title')}</h1>               
                </Col>
                <Col></Col>
            </Row>
            <Row className='p-3'>
                <Col className="">
                    <Row>
                        <Col className='text-center'>
                            <h2 className='mb-3'>{t('forgot.question')}</h2>
                            <h3 className='mb-3'>{t('forgot.help1')}</h3>
                            <div>{t('forgot.help2')}</div>
                        </Col>
                    </Row>
                    <Form className="p-4 formulario" onSubmit={handleSubmit}>                        
                        <Row className="text-center my-3">
                            <Form.Control placeholder={t('forgot.email')} name="email" className="sd-input" type="email" autoComplete="off" />
                        </Row>
                        <Row className="text-center my-5 justify-content-center">
                            <Button variant='primary' type="submit" id="kt_password_reset_submit" className="btn-primary w-85">
                                {isLoading
                                    ?
                                    <>
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </>
                                    :
                                    <>{t('forgot.submit')}</>
                                }
                            </Button>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    )    
}
